/**
 * As cores e fontes da mesa para a página do plugin: o SDK as põe como variáveis CSS
 * (`--rd-face-color`…), e o `rpgdesk.css` usa (docs/spec/web-plugins.md, "Tema"). Os papéis são os
 * de `ui/theme.css`.
 */
const VARS = [
  'face-color',
  'face-color-hover',
  'face-color-deemphasized',
  'face-color-little-deemphasized',
  'face-selection-color',
  'dominant-color',
  'dominant-color-hover',
  'dominant-color-dark',
  'dominant-color-pale',
  'dominant-color-text',
  'bkg-color',
  'dark-bkg-color',
  'secondary-bkg-color',
  'emphasized-secondary-bkg-color',
  'tertiary-bkg-color',
  'content-bkg-color',
  'short-content-bkg-color',
  'text-content',
  'text-content-deemphasized',
  'text-content-high-contrast',
  'error-color',
  'warning-color',
  'online-color',
  'font-default',
  'font-title',
  'font-console',
  'font-size',
] as const;

export function themeVars(): Record<string, string> {
  const style = getComputedStyle(document.documentElement);
  const out: Record<string, string> = {};
  for (const name of VARS) {
    const value = style.getPropertyValue(`--${name}`).trim();
    if (value) out[name] = value;
  }
  return out;
}
